<template>
    <ResponsiveDialog
        v-model="internalValue"
        :max-width="520"
        :header-title="$t('dashboard.gameRules.panel7.catchOdds.dialogTitle')"
    >
        <v-card-text class="catch-odds__scroll">
            <div v-html="$t('dashboard.gameRules.panel7.catchOdds.intro')"></div>

            <h3>{{ $t('dashboard.gameRules.panel7.catchOdds.overkillTitle') }}</h3>
            <div v-html="$t('dashboard.gameRules.panel7.catchOdds.overkillBody')"></div>

            <h3>{{ $t('dashboard.gameRules.panel7.catchOdds.exampleTitle') }}</h3>
            <div v-html="$t('dashboard.gameRules.panel7.catchOdds.exampleIntro')"></div>

            <div class="catch-odds__table-title">{{ $t('dashboard.gameRules.panel7.catchOdds.level3TableTitle') }}</div>
            <v-simple-table dense class="catch-odds__table">
                <thead>
                    <tr>
                        <th>{{ $t('dashboard.gameRules.panel7.catchOdds.tableHpHeader') }}</th>
                        <th>{{ $t('dashboard.gameRules.panel7.catchOdds.tableChanceHeader') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in level3Rows" :key="row.hp">
                        <td>{{ row.hp }}</td>
                        <td>{{ row.chance }}</td>
                    </tr>
                </tbody>
            </v-simple-table>

            <div class="catch-odds__table-title">{{ $t('dashboard.gameRules.panel7.catchOdds.level6TableTitle') }}</div>
            <v-simple-table dense class="catch-odds__table">
                <thead>
                    <tr>
                        <th>{{ $t('dashboard.gameRules.panel7.catchOdds.tableHpHeader') }}</th>
                        <th>{{ $t('dashboard.gameRules.panel7.catchOdds.tableChanceHeader') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in level6Rows" :key="row.hp">
                        <td>{{ row.hp }}</td>
                        <td>{{ row.chance }}</td>
                    </tr>
                </tbody>
            </v-simple-table>

            <div v-html="$t('dashboard.gameRules.panel7.catchOdds.outro')"></div>

            <div class="catch-odds__scroll-spacer"/>
        </v-card-text>
    </ResponsiveDialog>
</template>

<script>
    import ResponsiveDialog from '@/components/utils/ResponsiveDialog';

    export default {
        name: 'CatchOddsDialog',
        components: {ResponsiveDialog},
        props: {
            value: {type: Boolean, default: false},
        },
        data() {
            return {
                // "Mistrovstvi pokeballu" = 5 u obou levelu - viz claude/game-rules/catching-encounters.md, sekce "Overkill a zaporne HP"
                level3Rows: [
                    {hp: '6', chance: '9 %'},
                    {hp: '4', chance: '27 %'},
                    {hp: '2', chance: '45 %'},
                    {hp: '0', chance: '64 %'},
                    {hp: '-2', chance: '82 %'},
                    {hp: '-4 a méně', chance: '100 %'},
                ],
                level6Rows: [
                    {hp: '6', chance: '3 %'},
                    {hp: '0', chance: '21 %'},
                    {hp: '-6', chance: '38 %'},
                    {hp: '-12', chance: '56 %'},
                    {hp: '-18', chance: '74 %'},
                    {hp: '-24', chance: '91 %'},
                    {hp: '-27 a méně', chance: '100 %'},
                ],
            }
        },
        computed: {
            internalValue: {
                get() {
                    return this.value;
                },
                set(v) {
                    this.$emit('input', v);
                },
            },
        },
    }
</script>

<style scoped>
    .catch-odds__scroll {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
    }

    .catch-odds__table-title {
        font-weight: 700;
        margin-top: 10px;
    }

    .catch-odds__table {
        margin: 4px 0 16px;
    }

    /* stejny princip jako .type-chart__scroll-spacer v TypeChartDialog.vue - misto pro plovouci zaviraci krizek (ResponsiveDialog, mobil) */
    .catch-odds__scroll-spacer {
        height: var(--responsive-dialog-close-clearance);
    }
</style>
